import { Link } from 'react-router-dom';

/**
 * Lincoln School logo mark.
 * Yellow square with serif "m" in blue, followed by the Lincoln School wordmark.
 */
export default function Logo({ size = 36, inverted = false }) {
  const textColor = inverted ? '#fff' : '#102a4a';
  return (
    <Link to="/" className="inline-flex items-center gap-2.5 flex-shrink-0">
      <span
        className="inline-flex items-center justify-center font-serif font-bold text-brand-blue flex-shrink-0"
        style={{ width: size, height: size, background: '#f0b80c', borderRadius: 4, fontSize: size * 0.7, lineHeight: 1 }}
      >
        m
      </span>
      <span className="flex flex-col leading-none whitespace-nowrap">
        <span className="font-serif font-bold text-brand-yellow tracking-tight" style={{ fontSize: 20 }}>Lincoln</span>
        <span className="font-serif font-bold tracking-tight" style={{ fontSize: 20, color: textColor, marginTop: -2 }}>School</span>
      </span>
    </Link>
  );
}
